interface TagBadgeProps {
  label: string;
  tone?: "default" | "accent";
}

export default function TagBadge({ label, tone = "default" }: TagBadgeProps) {
  const toneClass =
    tone === "accent"
      ? "bg-accent-100 text-accent-900"
      : "bg-secondary-100 text-secondary-900";
  return (
    <span
      className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs font-label whitespace-nowrap ${toneClass}`}
    >
      {label}
    </span>
  );
}